"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultVariant = getDefaultVariant;
exports.selectVariantDefinition = selectVariantDefinition;
exports.selectVariant = selectVariant;
const helpers_1 = require("./client/helpers");
const hash_1 = __importDefault(require("./hash"));
const VARIANT_HASH_SEED = 86028157;
function getDefaultVariant() {
    return {
        name: "disabled",
        enabled: false,
        feature_enabled: false,
    };
}
function randomString() {
    return String(Math.round(Math.random() * 100000));
}
const stickinessSelectors = ["userId", "sessionId", "remoteAddress"];
function getSeed(context, stickiness = "default") {
    if (stickiness !== "default") {
        const value = (0, helpers_1.resolveContextValue)(context, stickiness);
        return value ? value.toString() : randomString();
    }
    let result;
    stickinessSelectors.some((key) => {
        const value = context[key];
        if (typeof value === "string" && value !== "") {
            result = value;
            return true;
        }
        return false;
    });
    return result || randomString();
}
function overrideMatchesContext(context) {
    return (o) => o.values.some((value) => value === (0, helpers_1.resolveContextValue)(context, o.contextName));
}
function findOverride(variants, context) {
    return variants
        .filter((variant) => variant.overrides)
        .find((variant) => variant.overrides?.some(overrideMatchesContext(context)));
}
function selectVariantDefinition(groupId, stickiness, variants, context) {
    const totalWeight = variants.reduce((acc, v) => acc + v.weight, 0);
    if (totalWeight <= 0) {
        return null;
    }
    const variantOverride = findOverride(variants, context);
    if (variantOverride) {
        return variantOverride;
    }
    const target = (0, hash_1.default)(getSeed(context, stickiness), groupId, totalWeight, VARIANT_HASH_SEED);
    let counter = 0;
    const variant = variants.find((v) => {
        if (v.weight === 0) {
            return undefined;
        }
        counter += v.weight;
        if (counter < target) {
            return undefined;
        }
        return v;
    });
    return variant || null;
}
function selectVariant(feature, context) {
    const stickiness = feature.variants?.[0]?.stickiness ?? undefined;
    return selectVariantDefinition(feature.name, stickiness, feature.variants || [], context);
}
